document.addEventListener("DOMContentLoaded", function () {
  const body = document.body;
  const questionItems = document.querySelectorAll(".p-faq__question-item");
  const answerItems = document.querySelectorAll(".p-faq__answer-item");
  const closeButtons = document.querySelectorAll(".p-faq__close-btn");

  questionItems.forEach((item, index) => {
    item.addEventListener("click", function (event) {
      event.stopPropagation();
      const correspondingAnswer = answerItems[index];

      // 他のquestion-itemの背景をリセット
      questionItems.forEach(q => (q.style.backgroundColor = ""));

      answerItems.forEach(answer => {
        if (answer !== correspondingAnswer) {
          if (answer.classList.contains("active")) {
            answer.classList.add("closing");
            unlockBodyScroll();
          }
        }
      });

      correspondingAnswer.classList.toggle("active");
      if (correspondingAnswer.classList.contains("active")) {
        lockBodyScroll();
        this.style.backgroundColor = "#E2E8F2"; // クリックされたquestion-itemの背景を変更
      } else {
        unlockBodyScroll();
        this.style.backgroundColor = ""; // 背景をリセット
      }
    });
  });

  document.addEventListener("click", function () {
    answerItems.forEach(answer => {
      if (answer.classList.contains("active")) {
        answer.classList.add("closing");
        unlockBodyScroll();
      }
    });
    // すべてのquestion-itemの背景をリセット
    questionItems.forEach(q => (q.style.backgroundColor = ""));
  });

  closeButtons.forEach((btn, index) => {
    btn.addEventListener("click", function (event) {
      event.stopPropagation();
      const correspondingAnswer = answerItems[index];
      correspondingAnswer.classList.add("closing");
      unlockBodyScroll();
      // 対応するquestion-itemの背景をリセット
      questionItems[index].style.backgroundColor = "";
    });
  });

  answerItems.forEach((answer, index) => {
    answer.addEventListener("animationend", function () {
      if (this.classList.contains("closing")) {
        this.classList.remove("active", "closing");
        unlockBodyScroll();
        // 対応するquestion-itemの背景をリセット
        questionItems[index].style.backgroundColor = "";
      }
    });
  });

  function lockBodyScroll() {
    body.style.overflow = "hidden";
  }

  function unlockBodyScroll() {
    body.style.overflow = "";
  }
});
